import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Router } from '@angular/router';
import { Injectable } from "@angular/core";
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable()
export class AuthInterceptor implements HttpInterceptor{

    constructor(private router:Router) {
      
    
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>{
        let clonedReq = null;
        if(localStorage.getItem('VMS')!=null) {
            if(!req.headers.has("InterceptorSkipHeader")){
             clonedReq =req.clone({
                headers: req.headers.set('Authorization','Bearer '+ localStorage.getItem('VMS'))
            });
        }
        else {
            clonedReq =req;
            console.log(clonedReq);
        }
            return next.handle(clonedReq).pipe(
                tap(
                    succ =>{},
                    err =>{
                        if(err.status == 401)
                        {
                            localStorage.removeItem('VMS');
                            this.router.navigateByUrl('/login');
                        }
                    }
                )
            )
        }
        else{
            return next.handle(req.clone());
        }
    }
}